var addToPackBtn, packs, product, productImg, productImgUrl, productPrice, packProductElm, packProductImg, packPrice,
    packOldPrice, packNewPrice, packSizes, packOldPriceValue,  packNewPriceValue = 0, delBtn, evtTarget, packDel, removeBtn, changeImg, resetInput,
    itemPrice, currentOldPrice, packProductPrice, idVariants, productVariants,productItem, countProductItem = 0;

const urlParams = new URLSearchParams(window.location.search);
const packProducts = document.querySelector('.packs-bar__products');

addEventListener('DOMContentLoaded', async function () {
    createPack();
    document.getElementById('packs-bar__progress-button__count').innerHTML = '0/' + packSizes;
})

function getHeightCollecitonPackBar() {
    var packsbarProducts = document.querySelector('.component-pack-summary .packs-bar__products').offsetHeight,
        screenPP = window.matchMedia("(min-width: 750px)"),
        packsbarSummaryHead = document.querySelector('.component-pack-summary .packs-bar__summary__head');

    if (screenPP.matches) {
        packsbarSummaryHead.setAttribute('style', 'padding-bottom: 0px');
    } else {
        packsbarSummaryHead.setAttribute('style', 'padding-bottom: calc(25px + '+ packsbarProducts +'px)');
    }
}
function createPack() {
    packSizes = urlParams.get('pack_size');
    document.getElementById('quantity-pack').innerHTML = packSizes;
    for (let i = 0; i < packSizes; i++) {
        packProductElm = createElementPack();
        packProducts.append(packProductElm);
        getHeightCollecitonPackBar()
    }
}
function createElementPack() {
    const el = document.createElement('div');
    const elImg = document.createElement('img');

    el.classList.add("packs-bar__product", "product-pack-add-cart");

    elImg.classList.add("packs-bar__image", "packs-bar__image--placeholder");
    elImg.setAttribute('src', '//cdn.shopify.com/s/files/1/0580/6322/5001/t/4/assets/icon-sock.svg');

    const properties = ['_packItemPrice', '_idVariants'];

    properties.forEach(function (e, i) {
        const elInput = document.createElement('input');

        elInput.classList.add("product-form__input");
        elInput.setAttribute('type', 'hidden');
        elInput.setAttribute('name', 'properties[' + e + ']');

        el.append(elInput);
    })
    el.append(elImg);
    return el;
}
function addToPack(productVariants, priceVariant, el, idFormData, isQuickView = false, img = null) {
    addToPackBtn    = document.querySelectorAll('.add-to-pack');
    packs           = document.querySelectorAll('.packs-bar__product');
    packPrice       = document.querySelectorAll('.packs-bar__price');
    packOldPrice    = document.querySelector('.packs-bar__old-price');
    packNewPrice    = document.querySelector('.packs-bar__price');
    packOldPriceValue = packOldPrice.getAttribute('data-price');

    if(countProductItem >= Number(packSizes)) {
        return
    }

    product         = el.closest('.featured-product');
    let container = el.closest('.custom-grid-item');
    if (window.innerWidth < 990 && isQuickView == false) {
        showOptionProductMobile(container)
    }
    let packBar = document.querySelector('.packs-bar');
    if(packBar && window.innerWidth < 990) {
        packBar.style.display = "block";
    }
    let packItemQty = product.querySelector('.product-tile__pack-label')
    let dataQty = Number(packItemQty.getAttribute('data-qty'));
    packItemQty.setAttribute('data-qty', dataQty + 1);
    if(dataQty == 0) {
        packItemQty.innerHTML = dataQty + 1 + ' ' + announce_more_pack;
    } else {
        packItemQty.innerHTML = dataQty + 1 + ' ' + announce_more_packs;
    }
    packItemQty.classList.add('active')
    packItemQty.style.transform = "translateX(0%)";
    let idLabelNotification = packItemQty.getAttribute('id')
    setTimeout(function () {
        packItemQty.style.transform = "translateX(-120%)";
    },3200)
    setTimeout(function (){
        packItemQty.classList.remove('active')
    },3500)

    productImg      = product.querySelector('img.motion-reduce');
    if(img != null) {productImg      = img;}
    let src =  productImg.getAttribute('src').split('?');

    productPrice    = formatPrice(String(priceVariant));
    let version = src[1].split('&')[0]
    productImgUrl   = src[0] + '?' + version + '&width=150';
    packOldPriceValue = parseFloat(packOldPriceValue) + parseFloat(productPrice);

    packNewPriceValue = parseFloat(packNewPriceValue) + Math.round(((parseFloat((parseFloat(productPrice) * (1 - (Number(configPack[packSizes]) / 100))))) + Number.EPSILON) * 100) / 100;
    packNewPrice.innerHTML = convertCurrencyLocation(convertDecimalMoney(packNewPriceValue.toFixed(2)));

    packOldPrice.innerHTML = convertCurrencyLocation(convertDecimalMoney(packOldPriceValue.toFixed(2)));
    packOldPrice.setAttribute('data-price', packOldPriceValue.toFixed(2));
    packNewPrice.setAttribute('data-price', packNewPriceValue);

    for(let i = 0; i < packs.length; i++) {
        if(!(packs[i].classList.contains('packs-bar__image--product'))) {
            document.getElementById('action-edit-item-pack').classList.remove('tw-pointer-events-none');
            packs[i].setAttribute('data-id-form', idFormData);
            packs[i].setAttribute('data-id-notification', idLabelNotification);
            packs[i].classList.add('packs-bar__image--product');
            packProductImg      = packs[i].querySelector('img');
            packProductPrice    = packs[i].querySelector('[name="properties[_packItemPrice]"]');
            idVariants          = packs[i].querySelector('[name="properties[_idVariants]"]');

            packProductImg.setAttribute('src', productImgUrl);
            packProductPrice.setAttribute('value', productPrice);

            idVariants.setAttribute('value', productVariants);

            countProductItem++;

            var packsbarProgress = document.querySelector('.packs-bar__progress__inner');
            var packsbarProgressMB = document.querySelector('.packs-bar__progress__inner_mb');
            let ac = 100 / packSizes * countProductItem
            packsbarProgress.setAttribute('style', 'width:'+ ac +'%');
            packsbarProgressMB.setAttribute('style', 'width:'+ ac +'%');

            document.getElementById('action-edit-item-pack').classList.add("have-product");
            document.getElementById('packs-bar__progress-button__count').innerHTML = countProductItem + '/' + packSizes;
            document.getElementById('packs-bar__progress-button__text').innerHTML = button__text;
            createDelBtn(packs[i]);
            if(countProductItem == packSizes) {
                document.getElementById('action-edit-item-pack').classList.add('full-pack');
                document.getElementById('packs-bar__progress-button__text').innerHTML = pack_edit + ' ' + countProductItem + '/' + packSizes;

                let btnSubmit = document.getElementById('btn-submit-pack-to-cart');
                btnSubmit.classList.remove('isHidden')
                btnSubmit.classList.remove('disabled')
                btnSubmit.classList.add('btn-submit-pack-to-cart')

                if (window.innerWidth < 990) {
                    btnSubmit.style.transform = 'translateX(108%)';
                }

                btnSubmit.classList.add('tw-cursor-pointer')
                btnSubmit.disabled = false;
                btnSubmit.onclick = function () {
                    addPackToCart('normal', collectionType)
                    document.querySelector('.component-pack-summary').classList.add('close-packbar');
                };
            }
            return;
        }
    }
}
async function refreshPack() {
    let btnRemoveItemPack = document.getElementsByClassName('packs-bar__remove');
    for (let i = btnRemoveItemPack.length; i > 0; i--) {
        btnRemoveItemPack[i -1].click()
    }
}
function createDelBtn(pack) {
    const el = document.createElement('button');
    const elEdit = document.createElement('button');
    const elImg = document.createElement('img');

    el.classList.add('packs-bar__remove');
    el.setAttribute('id', 'btn-remove-item-pack-' + Date.now())
    el.addEventListener('click', function handleClick(evt) {
        deleteProductPack(evt);
    })

    elEdit.classList.add('packs-bar__edit', '!tw-hidden');
    elEdit.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><path d="M0 0h16v16H0z"/><g fill="#B0B0B0"><path d="M8.695 3.971l3.334 3.334a.667.667 0 0 0 .943-.943L9.638 3.029a.667.667 0 1 0-.943.942z"/><path d="M1.672 10.052c-.08.081-.14.18-.17.29l-1.31 4.643a.667.667 0 0 0 .822.823l4.644-1.31c.11-.03.21-.089.29-.17l9-9a3.025 3.025 0 0 0-4.276-4.276l-9 9zm3.456 3.21l-3.33.94.94-3.33 8.877-8.877a1.69 1.69 0 1 1 2.39 2.39l-8.877 8.878z"/></g></g></svg>';
    elEdit.addEventListener('click', function handleClick(evt) {
        showPopUpEdit(evt);
    })

    elImg.setAttribute('src', '//cdn.shopify.com/s/files/1/0580/6322/5001/t/4/assets/icon-delete.svg');

    el.append(elImg);
    pack.append(el);
    pack.append(elEdit);
}
function deleteProductPack(evt) {
    packOldPrice    = document.querySelector('.packs-bar__old-price');
    packNewPrice    = document.querySelector('.packs-bar__price');

    evtTarget   = evt.target;
    packDel     = evtTarget.closest('.packs-bar__product');
    itemPrice   = packDel.querySelector('[name="properties[_packItemPrice]"]').value;

    removeBtn   = packDel.querySelector('.packs-bar__remove')
    let removeEdit   = packDel.querySelector('.packs-bar__edit')
    changeImg   = packDel.querySelector('img');
    resetInput  = packDel.querySelectorAll('.product-form__input');

    currentOldPrice = packOldPrice.getAttribute('data-price');
    currentOldPrice = parseFloat(currentOldPrice) - parseFloat(itemPrice);

    currentNewPrice = parseFloat(packNewPrice.getAttribute('data-price'));

    packOldPrice.innerHTML = convertCurrencyLocation(convertDecimalMoney(currentOldPrice.toFixed(2)));
    packOldPrice.setAttribute('data-price', currentOldPrice.toFixed(2));

    packNewPriceValue = parseFloat(currentNewPrice) - Math.round(((parseFloat((parseFloat(itemPrice) * (1 - (Number(configPack[packSizes]) / 100))))) + Number.EPSILON) * 100) / 100;
    packNewPrice.innerHTML = convertCurrencyLocation(convertDecimalMoney(packNewPriceValue.toFixed(2)));
    packNewPrice.setAttribute('data-price', packNewPriceValue.toFixed(2));

    packDel.classList.remove('packs-bar__image--product');
    removeBtn.remove();
    removeEdit.remove();
    changeImg.setAttribute('src', '//cdn.shopify.com/s/files/1/0580/6322/5001/t/4/assets/icon-sock.svg');
    resetInput.forEach(function (e, i){
        e.value = '';
    });
    countProductItem--;
    if(countProductItem == 0 ) {
        let btnActionEditItem = document.getElementById('action-edit-item-pack');
        document.getElementById('packs-bar__progress-button__text').innerHTML = btn_add_pack_mobile;
        btnActionEditItem.classList.remove("have-product");
        btnActionEditItem.classList.add('tw-pointer-events-none');
    }

    if(countProductItem < packSizes) {
        document.getElementById('action-edit-item-pack').classList.remove('full-pack');

        let btnSubmit = document.getElementById('btn-submit-pack-to-cart');
        btnSubmit.classList.add('isHidden')
        btnSubmit.classList.add('disabled')
        btnSubmit.classList.remove('btn-submit-pack-to-cart')
        if (window.innerWidth < 990) {
            btnSubmit.style.transform = 'translateX(300%)';
        }

        btnSubmit.classList.remove('tw-cursor-pointer')
        btnSubmit.disabled = true;
        document.getElementById('packs-bar__progress-button__text').innerHTML = (countProductItem == 0) ? btn_add_pack_mobile : button__text;
    }
    sortOrderPack();
    var packsbarProgress = document.querySelector('.packs-bar__progress__inner');
    var packsbarProgressMB = document.querySelector('.packs-bar__progress__inner_mb');
    let ac = 100 / packSizes * countProductItem
    packsbarProgress.setAttribute('style', 'width:'+ ac +'%');
    packsbarProgressMB.setAttribute('style', 'width:'+ ac +'%');
    document.getElementById('packs-bar__progress-button__count').innerHTML = countProductItem + '/' + packSizes;

    let packItemQty = document.getElementById(packDel.getAttribute('data-id-notification'))
    let dataQty = Number(packItemQty.getAttribute('data-qty'));
    packItemQty.setAttribute('data-qty', dataQty - 1);
    if(dataQty == 2) {
        packItemQty.innerHTML = dataQty - 1 + ' ' + announce_more_pack;
    } else {
        packItemQty.innerHTML = dataQty - 1 + ' ' + announce_more_packs;
    }
    packDel.removeAttribute('data-id-form')
    packDel.removeAttribute('data-id-notification')
}
function beforeAddToPack(formName) {
    let el = document.querySelector('.index-size.show');
    let formData = document.getElementById(formName);
    let variantId = formData.querySelector('[name="id"]').value;
    let formId = formName.replace('product-form-','');
    // let dataForm = document.getElementById(formName).querySelector('.variants-product-form').textContent;
    let dataForm = document.querySelector('[data-section="' + formId + '"]').querySelector('[type="application/json"]').textContent;
    console.log(document.getElementById(formName));
    let priceVariant = 0
    dataForm = JSON.parse(dataForm);
    let variants = dataForm;
    variants.forEach(function (item) {
        if(item['id'] == variantId) {
            priceVariant = item['price'];
            return
        }
    });
    if(priceVariant == 0) {
        let variants = el.closest('li').querySelector('[type="application/json"]').textContent;
        variants = JSON.parse(variants);
        variants.forEach(function (item) {
            if(item['id'] == variantId) {
                priceVariant = item['price'];
                return
            }
        });
    }
    addToPack(variantId, priceVariant, el, formName)
}

window.addEventListener('load', function() {
    var btnSimple = document.getElementsByClassName('btn-simple');
    if(btnSimple.length > 0) {
        for(let i=0 ; i< btnSimple.length; i++) {
            if(!btnSimple[i].classList.contains('isAddEvent')) {
                btnSimple[i].addEventListener("click", async () => {
                    let parent = btnSimple[i].closest('variant-radios');
                    let dataSection = parent.getAttribute('data-section');
                    var formName = 'product-form-' + dataSection;
                    beforeAddToPack( formName)
                });
                btnSimple[i].classList.add('isAddEvent');
            }
        }
    }
    triggerBtnSize();

    var radioSelector = document.querySelectorAll("input[type=radio]");
    radioSelector.forEach( option => {
        if(!option.classList.contains('isAddEvent')) {
            option.addEventListener("click", async () => {
                updateVariant(option)
                var formName = option.getAttribute('idForm') || option.form.attributes.id.value;
                if(option.name != "Color"){
                    beforeAddToPack(formName)
                }
            });
            option.classList.add('isAddEvent');
        }
    });
})

function triggerBtnSize() {
    var urlParamsOnPack = new URLSearchParams(window.location.search);
    if(urlParamsOnPack.get('view') === 'pack') {
        var containerWapperCards = document.querySelectorAll('.custom-grid-item');
        containerWapperCards.forEach((item) => {
            let btn_trigger_size = item.querySelector('.btn_trigger_size');
            btn_trigger_size.onclick = function() {
                showOptionProductMobile(item)
            };
        })
    }
}

function sortOrderPack() {
    function comparatorPack(a, b) {
        if(!b.classList.contains('packs-bar__image--product')) {
            return -1;
        }
    }

    let itemPacks = document.querySelector(".packs-bar__products");
    if(itemPacks) {
        let itemPack = itemPacks.querySelectorAll('.packs-bar__product');
        itemPack = Array.prototype.slice.call( itemPack, 0 );
        let sorted = itemPack.sort(comparatorPack);
        if(sorted.length > 0) {
            for (let j= 0 ;j < sorted.length; j++) {
                itemPacks.append(sorted[j])
            }
        }
    }
}